<div class="alert alert-red is-active container" *ngIf="error">
    {{ errorMessage }}
</div>
<div class="bootstrap-wrapper">
    <div *ngIf="!error" id="onemap-report" class="planning-stats-draft-tip-report">
        <div class="reportSectionContainer title">
            <div class="reportSectionHeader">
                Planning Statistics
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-12">
                        Pennsylvania's Transportation Planning Organizations Bridge and Roadway Status
                    </div>
                </div>
            </div>
        </div>
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                Non-Interstate Bridges (State and Local) - Current Draft TIP
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="pie-container">
                            <canvas #nonInterstateBridgesChartCanvas class="non-interstate-bridges-chart"
                                id="non-interstate-bridges-chart" width="100%" height="100%"></canvas>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tipTableSection" *ngIf="reportData && reportData.planningStatsTipData">
                <table class="tipTable table-condensed bridges-table" aria-label="Non-Interstate Bridges (State and Local) - Current Draft TIP">
                    <thead>
                        <tr>
                            <th>Non Interstate Bridges (State and Local) - current Draft TIP</th>
                            <th>Deck Area</th>
                            <th>Percent of Total Deck Area %</th>
                            <th>Number of Bridges</th>
                            <th>Bridge Totals</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="first-color">Structurally Deficient, Programmed, Construction Phase</td>
                            <td>{{ reportData.planningStatsTipData[0]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[0]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[0]?.cnt }}</td>
                            <td class="border-top"></td>
                        </tr>
                        <tr>
                            <td class="second-color">Structurally Deficient, Programmed, Other Phase</td>
                            <td>{{ reportData.planningStatsTipData[1]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[1]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[1]?.cnt }}</td>
                            <td class="total">
                                <b>{{ (reportData.planningStatsTipData[0]?.cnt-0) + (reportData.planningStatsTipData[1]?.cnt-0) + (reportData.planningStatsTipData[2]?.cnt-0) | number }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="third-color">Structurally Deficient, Not Programmed</td>
                            <td>{{ reportData.planningStatsTipData[2]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[2]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[2]?.cnt }}</td>
                            <td class="border-bottom"></td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="fourth-color">Functionally Obselete, Programmed, Construction Phase</td>
                            <td>{{ reportData.planningStatsTipData[3]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[3]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[3]?.cnt }}</td>
                            <td class="border-top"></td>
                        </tr>
                        <tr>
                            <td class="fifth-color">Functionally Obselete, Programmed, Other Phase</td>
                            <td>{{ reportData.planningStatsTipData[4]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[4]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[4]?.cnt }}</td>
                            <td class="total">
                                <b>{{ (reportData.planningStatsTipData[3]?.cnt-0) + (reportData.planningStatsTipData[4]?.cnt-0) + (reportData.planningStatsTipData[5]?.cnt-0) | number }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="sixth-color">Functionally Obselete, Not Programmed</td>
                            <td>{{ reportData.planningStatsTipData[5]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[5]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[5]?.cnt }}</td>
                            <td class="border-bottom"></td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="seventh-color">Good</td>
                            <td>{{ reportData.planningStatsTipData[6]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[6]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[6]?.cnt }}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr>
                            <td><b>Totals</b></td>
                            <td><b>{{ reportData.planningStatsTipData[7]?.da }}</b></td>
                            <td><b>{{ reportData.planningStatsTipData[7]?.pctDa }}</b></td>
                            <td><b>{{ reportData.planningStatsTipData[7]?.cnt }}</b></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="tipTableSection" *ngIf="reportData && reportData.planningStatsTipData">
                <table class="tipTable table-condensed" aria-label="Non-Interstate Bridges (State and Local) - Current Draft TIP">
                    <thead>
                        <tr>
                            <th>Posted Non Interstate Bridges (State and Local) - current Draft TIP</th>
                            <th>Deck Area</th>
                            <th>Percent of Total Deck Area %</th>
                            <th>Number of Bridges</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Posted, Programmed, Construction Phase (Includes SD and FO)</td>
                            <td>{{ reportData.planningStatsTipData[8]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[8]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[8]?.cnt }}</td>
                        </tr>
                        <tr>
                            <td>Posted, Programmed, Other Phase (Includes SD and FO)</td>
                            <td>{{ reportData.planningStatsTipData[9]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[9]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[9]?.cnt }}</td>
                        </tr>
                        <tr>
                            <td>Posted, Not Programmed</td>
                            <td>{{ reportData.planningStatsTipData[10]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[10]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[10]?.cnt }}</td>
                        </tr>
                        <tr>
                            <td><b>Totals</b></td>
                            <td><b>{{ reportData.planningStatsTipData[11]?.da }}</b></td>
                            <td><b>{{ reportData.planningStatsTipData[11]?.pctDa }}</b></td>
                            <td><b>{{ reportData.planningStatsTipData[11]?.cnt }}</b></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                Interstate Bridges- Current Draft TIP
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="pie-container">
                            <canvas #interstateBridgesChart class="interstate-bridges-chart"
                                id="interstate-bridges-chart" width="100%" height="100%"></canvas>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tipTableSection" *ngIf="reportData && reportData.planningStatsTipData">
                <table class="tipTable table-condensed" aria-label="Interstate Bridges- Current Draft TIP">
                    <thead>
                        <tr>
                            <th>Interstate Bridges - current Draft TIP</th>
                            <th>Deck Area</th>
                            <th>Percent of Total Deck Area %</th>
                            <th>Number of Bridges</th>
                            <th>Bridge Totals</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="first-color">Structurally Deficient, Programmed, Construction Phase</td>
                            <td>{{ reportData.planningStatsTipData[12]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[12]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[12]?.cnt }}</td>
                            <td class="border-top"></td>
                        </tr>
                        <tr>
                            <td class="second-color">Structurally Deficient, Programmed, Other Phase</td>
                            <td>{{ reportData.planningStatsTipData[13]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[13]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[13]?.cnt }}</td>
                            <td class="total">
                                <b>{{ (reportData.planningStatsTipData[12]?.cnt-0) + (reportData.planningStatsTipData[13]?.cnt-0) + (reportData.planningStatsTipData[14]?.cnt-0) | number }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="third-color">Structurally Deficient, Not Programmed</td>
                            <td>{{ reportData.planningStatsTipData[14]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[14]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[14]?.cnt }}</td>
                            <td class="border-bottom"></td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="fourth-color">Functionally Obselete, Programmed, Construction Phase</td>
                            <td>{{ reportData.planningStatsTipData[15]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[15]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[15]?.cnt }}</td>
                            <td class="border-top"></td>
                        </tr>
                        <tr>
                            <td class="fifth-color">Functionally Obselete, Programmed, Other Phase</td>
                            <td>{{ reportData.planningStatsTipData[16]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[16]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[16]?.cnt }}</td>
                            <td class="total">
                                <b>{{ (reportData.planningStatsTipData[15]?.cnt-0) + (reportData.planningStatsTipData[16]?.cnt-0) + (reportData.planningStatsTipData[17]?.cnt-0) | number }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="sixth-color">Functionally Obselete, Not Programmed</td>
                            <td>{{ reportData.planningStatsTipData[17]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[17]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[17]?.cnt }}</td>
                            <td class="border-bottom"></td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="seventh-color">Good</td>
                            <td>{{ reportData.planningStatsTipData[18]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[18]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[18]?.cnt }}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr>
                            <td><b>Totals</b></td>
                            <td><b>{{ reportData.planningStatsTipData[19]?.da }}</b></td>
                            <td><b>{{ reportData.planningStatsTipData[19]?.pctDa }}</b></td>
                            <td><b>{{ reportData.planningStatsTipData[19]?.cnt }}</b></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
                <table class="tipTable table-condensed" aria-label="Interstate Bridges- Current Draft TIP">
                    <thead>
                        <tr>
                            <th>Posted Interstate Bridges - current Draft TIP</th>
                            <th>Deck Area</th>
                            <th>Percent of Total Deck Area %</th>
                            <th>Number of Bridges</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Posted, Programmed, Construction Phase (Includes SD and FO)</td>
                            <td>{{ reportData.planningStatsTipData[20]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[20]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[20]?.cnt }}</td>
                        </tr>
                        <tr>
                            <td>Posted, Programmed, Other Phase (Includes SD and FO)</td>
                            <td>{{ reportData.planningStatsTipData[21]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[21]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[21]?.cnt }}</td>
                        </tr>
                        <tr>
                            <td>Posted, Not Programmed</td>
                            <td>{{ reportData.planningStatsTipData[22]?.da }}</td>
                            <td>{{ reportData.planningStatsTipData[22]?.pctDa }}</td>
                            <td>{{ reportData.planningStatsTipData[22]?.cnt }}</td>
                        </tr>
                        <tr>
                            <td><b>Totals</b></td>
                            <td><b>{{ reportData.planningStatsTipData[23]?.da }}</b></td>
                            <td><b>{{ reportData.planningStatsTipData[23]?.pctDa }}</b></td>
                            <td><b>{{ reportData.planningStatsTipData[23]?.cnt }}</b></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                Roadway Status
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="pie-container">
                            <canvas #interstateRoadStatus class="interstate-road-status" id="interstate-road-status"
                                width="100%" height="100%"></canvas>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tipTableSection" *ngIf="reportData">
                <table class="tipTable table-condensed" aria-label="Roadway Status">
                    <thead>
                        <tr>
                            <th>Interstate</th>
                            <th>Miles By Condition</th>
                            <th>Totals</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="first-color">Excellent and Good Not Addressed</td>
                            <td>
                                {{ reportData.interstateRoadMiles[0]?.unaddressed }}
                            </td>
                            <td class="border-top"></td>
                        </tr>
                        <tr>
                            <td class="second-color">Excellent and Good on Current TIP</td>
                            <td>
                                {{ reportData.interstateRoadMiles[0]?.tip }}
                            </td>
                            <td class="total">
                                <b>{{ (reportData.interstateRoadMiles[0]?.unaddressed-0) + (reportData.interstateRoadMiles[0]?.tip-0) + (reportData.interstateRoadMiles[0]?.draft-0) | number }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="third-color">Excellent and Good on Draft TIP</td>
                            <td>
                                {{ reportData.interstateRoadMiles[0]?.draft }}
                            </td>
                            <td class="border-bottom"></td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="fourth-color">Fair Not Addressed</td>
                            <td>
                                {{ reportData.interstateRoadMiles[1]?.unaddressed }}
                            </td>
                            <td class="border-top"></td>
                        </tr>
                        <tr>
                            <td class="fifth-color">Fair on Current TIP</td>
                            <td>
                                {{ reportData.interstateRoadMiles[1]?.tip }}
                            </td>
                            <td class="total">
                                <b>{{ (reportData.interstateRoadMiles[1]?.unaddressed-0) + (reportData.interstateRoadMiles[1]?.tip-0) + (reportData.interstateRoadMiles[1]?.draft-0) | number }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="sixth-color">Fair on Draft TIP</td>
                            <td>
                                {{ reportData.interstateRoadMiles[1]?.draft }}
                            </td>
                            <td class="border-bottom"></td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="seventh-color">Poor Not Addressed</td>
                            <td>
                                {{ reportData.interstateRoadMiles[2]?.unaddressed }}
                            </td>
                            <td class="border-top"></td>
                        </tr>
                        <tr>
                            <td class="eigth-color">Poor on Current TIP</td>
                            <td>
                                {{ reportData.interstateRoadMiles[2]?.tip }}
                            </td>
                            <td class="total">
                                <b>{{ (reportData.interstateRoadMiles[2]?.unaddressed-0) + (reportData.interstateRoadMiles[2]?.tip-0) + (reportData.interstateRoadMiles[2]?.draft-0) | number }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="ninth-color">Poor on Draft TIP</td>
                            <td>
                                {{ reportData.interstateRoadMiles[2]?.draft }}
                            </td>
                            <td class="border-bottom"></td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="tenth-color">Unknown IRI Not Addressed</td>
                            <td>
                                {{ reportData.interstateRoadMiles[3]?.unaddressed }}
                            </td>
                            <td class="border-top"></td>
                        </tr>
                        <tr>
                            <td class="eleventh-color">Unknown IRI on Current TIP</td>
                            <td>
                                {{ reportData.interstateRoadMiles[3]?.tip }}
                            </td>
                            <td class="total">
                                <b>{{ (reportData.interstateRoadMiles[3]?.unaddressed-0) + (reportData.interstateRoadMiles[3]?.tip-0) + (reportData.interstateRoadMiles[3]?.draft-0) | number }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="tewlfth-color">Unknown IRI on Draft TIP</td>
                            <td>
                                {{ reportData.interstateRoadMiles[3]?.draft }}
                            </td>
                            <td class="border-bottom"></td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td class="full-border">
                                <b>{{ totalInterstateMiles }}</b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="reportSectionContainer">
            <div class="reportSectionHeader">
                Non-Interstate Miles
            </div>
            <div class="reportSectionContent container">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="pie-container">
                            <canvas #nonInterstateRoadStatus class="non-interstate-road-status"
                                id="non-interstate-road-status" width="100%" height="100%"></canvas>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tipTableSection" *ngIf="reportData">
                <table class="tipTable table-condensed" aria-label="Non-Interstate Miles">
                    <thead>
                        <tr>
                            <th>Non Interstate</th>
                            <th>Miles By Condition</th>
                            <th>Totals</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="first-color">Excellent and Good Not Addressed</td>
                            <td>
                                {{ reportData.nonInterstateRoadMiles[0]?.unaddressed }}
                            </td>
                            <td class="border-top"></td>
                        </tr>
                        <tr>
                            <td class="second-color">Excellent and Good on Current TIP</td>
                            <td>
                                {{ reportData.nonInterstateRoadMiles[0]?.tip }}
                            </td>
                            <td class="total">
                                <b>{{ (reportData.nonInterstateRoadMiles[0]?.unaddressed-0) + (reportData.nonInterstateRoadMiles[0]?.tip-0) + (reportData.nonInterstateRoadMiles[0]?.draft-0) | number }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="third-color">Excellent and Good on Draft TIP</td>
                            <td>
                                {{ reportData.nonInterstateRoadMiles[0]?.draft }}
                            </td>
                            <td class="border-bottom"></td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="fourth-color">Fair Not Addressed</td>
                            <td>
                                {{ reportData.nonInterstateRoadMiles[1]?.unaddressed }}
                            </td>
                            <td class="border-top"></td>
                        </tr>
                        <tr>
                            <td class="fifth-color">Fair on Current TIP</td>
                            <td>
                                {{ reportData.nonInterstateRoadMiles[1]?.tip }}
                            </td>
                            <td class="total">
                                <b>{{ (reportData.nonInterstateRoadMiles[1]?.unaddressed-0) + (reportData.nonInterstateRoadMiles[1]?.tip-0) + (reportData.nonInterstateRoadMiles[1]?.draft-0) | number }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="sixth-color">Fair on Draft TIP</td>
                            <td>
                                {{ reportData.nonInterstateRoadMiles[1]?.draft }}
                            </td>
                            <td class="border-bottom"></td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="seventh-color">Poor Not Addressed</td>
                            <td>
                                {{ reportData.nonInterstateRoadMiles[2]?.unaddressed }}
                            </td>
                            <td class="border-top"></td>
                        </tr>
                        <tr>
                            <td class="eigth-color">Poor on Current TIP</td>
                            <td>
                                {{ reportData.nonInterstateRoadMiles[2]?.tip }}
                            </td>
                            <td class="total">
                                <b>{{ (reportData.nonInterstateRoadMiles[2]?.unaddressed-0) + (reportData.nonInterstateRoadMiles[2]?.tip-0) + (reportData.nonInterstateRoadMiles[2]?.draft-0) | number }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="ninth-color">Poor on Draft TIP</td>
                            <td>
                                {{ reportData.nonInterstateRoadMiles[2]?.draft }}
                            </td>
                            <td class="border-bottom"></td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr>
                            <td class="tenth-color">Unknown IRI Not Addressed</td>
                            <td>
                                {{ reportData.nonInterstateRoadMiles[3]?.unaddressed }}
                            </td>
                            <td class="border-top"></td>
                        </tr>
                        <tr>
                            <td class="eleventh-color">Unknown IRI on Current TIP</td>
                            <td>
                                {{ reportData.nonInterstateRoadMiles[3]?.tip }}
                            </td>
                            <td class="total">
                                <b>{{ (reportData.nonInterstateRoadMiles[3]?.unaddressed-0) + (reportData.nonInterstateRoadMiles[3]?.tip-0) + (reportData.nonInterstateRoadMiles[3]?.draft-0) | number }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="twelfth-color">Unknown IRI on Draft TIP</td>
                            <td>
                                {{ reportData.nonInterstateRoadMiles[3]?.draft }}
                            </td>
                            <td class="border-bottom"></td>
                        </tr>
                        <tr>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td class="full-border">
                                <b>{{ totalNonInterstateMiles }}</b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
